import { gql } from 'graphql-request';

const PopularActivities = gql`
  fragment PopularActivities on PopularActivityBlock {
    title
    blockType
    activities {
      ... on PageChooserBlock {
        page {
          ... on CustomActivityPage {
            slug
            title
            areaChoiceDisplay
            url
            theme {
              icon
              name
            }
            background: heroFallbackImage {
              ... on ImageObjectType {
                image: rendition(fill: "500x600-c100") {
                  url
                }
              }
            }
          }
          ... on ActivityPage {
            url
            activity {
              slug
              title
              areaChoiceDisplay
              theme {
                icon
                name
              }
              background: heroFallbackImage {
                ... on ImageObjectType {
                  image: rendition(fill: "500x600-c100") {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default PopularActivities;
